import { breakpoints } from '@bnnvara/breakpoints';
import { ThemeIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Theme';
import { Text } from '@bnnvara/typography';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { typography, space } from 'styled-system';

const getColor = (theme, themeSlug) => {
  const color = theme?.themes[themeSlug.replace('-', '_')].main;

  if (color) return color;
  return theme.base.white;
};

const Small = css`
  div {
    font-size: 14px;
  }
  svg {
    height: 8px;
    width: 8px;
  }
`;

const StyledThemeTagMedia = styled.span`
  display: inline-flex;
  align-items: center;
  text-transform: uppercase;
  cursor: pointer;

  div {
    color: ${({ theme, themeSlug }) => getColor(theme, themeSlug)};
    margin-top: 1px;
    font-size: 10px;
    font-weight: 700;

    ${breakpoints.md} {
      padding: 4px 0px;
      border-radius: 2px;
      color: ${({ theme, themeSlug }) => getColor(theme, themeSlug)};
      font-size: 12px;
      font-weight: 700;
      line-height: '12px';
    }
  }
  &:hover {
    div {
      color: ${({ theme, themeSlug }) => getColor(theme, themeSlug, 'dark')};
    }
    svg {
      * {
        fill: ${({ theme, themeSlug }) => getColor(theme, themeSlug, 'dark')};
      }
    }
  }
  &:active {
    div {
      color: ${({ theme, themeSlug }) => getColor(theme, themeSlug, 'light')};
    }
    svg {
      * {
        fill: ${({ theme, themeSlug }) => getColor(theme, themeSlug, 'light')};
      }
    }
  }

  ${breakpoints.md} {
    border-radius: 2px;
  }

  svg {
    height: 14px;
    width: 8px;
    padding-right: 4px;
    * {
      fill: ${({ theme, themeSlug }) => getColor(theme, themeSlug)};
    }
    ${breakpoints.md} {
      margin-top: 1px;
      height: 20px;
      width: 8px;
    }
  }

  ${({ size }) => size === 'sm' && Small};
  ${space}
  ${typography}
`;

export const ThemeTagMedia = ({
  children,
  themeSlug,
  size,
  theme,
  ...props
}) => {
  return (
    <Link href={`/thema/${themeSlug}`}>
      <StyledThemeTagMedia
        themeSlug={themeSlug}
        theme={theme}
        size={size}
        {...props}
      >
        <ThemeIcon />
        <Text>{children}</Text>
      </StyledThemeTagMedia>
    </Link>
  );
};

ThemeTagMedia.defaultProps = {
  size: 'md',
};

ThemeTagMedia.propTypes = {
  children: PropTypes.node.isRequired,
  iconLeft: PropTypes.node,
  themeSlug: PropTypes.string,
  theme: PropTypes.shape(),
  size: PropTypes.oneOf(['sm', 'md']),
};
